import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { YearPerformance } from '../model/year-performance';

@Injectable({
  providedIn: 'root'
})
export class YearPerformanceService {

  constructor(private http: HttpClient) { }

  // v1.0/performance/year?apexid=DAIK1&kpidate=2024-02
  getYearPerformanceByApexIdAndYear(apexId:string, year:string): Observable<YearPerformance[]> {
    // let url=`${environment.api.uri}v1.0/performance/year`;
    let url=`${environment.api.uri}v1.0/performance/year?apexid=${apexId}&kpidate=${year}`;
    // let url=`${environment.api.uri}v1.0/performance/month?apexid=${apexId}&kpidate=2024-01`;
    return this.http.get<YearPerformance[]>(url);
  }

}
